<template><div class="view">

	<main v-if="loading && !casting">
		Loading package...
	</main>

	<main v-if="!loading && nocastingfound">
		Casting not found...
	</main>

	<main v-if="casting">

		<div class="casting-viewer-header">

			<h1 class="h1">
				{{casting_title}}
			</h1>

			<div class="cols cols-2">
				<div>
					
					<div class="details">
						<div class="det" v-if="casting.from_name">
							<div class="pre">Package by </div> <div class="val">{{ (casting.from_name) ? casting.from_name : 'Anonymous' }}</div>
						</div>
						<div class="det" v-if="casting.from_email">
							<div class="pre">Email </div> <div class="val">{{casting.from_email}}</div>
						</div>
						<div class="det">
							<div class="pre">Date </div> <div class="val">{{casting._created}}</div>
						</div>							
					</div>					

				</div>
				<div>

					<div class="notes" v-if="casting.notes">
						<b>Notes</b><br>
						{{casting.notes}}					
					</div>

				</div>
			</div>

		</div>		

		<casting-items-list
			v-if="casting && casting.items"
			:itemgroups="casting_items_grouped"
			:can-remove-items="false"
		/>
			
	</main>

</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import CastingItemsList from '.././components/CastingItemsList'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		CastingItemsList, 
	},

	data(){ return {
		
		casting: undefined,
		loading: true,
		nocastingfound: false,

	}},

	computed: {

		uid(){ return this.route.params.uid },		

		casting_title(){
			if( !this.casting || !this.casting.title ) return 'Untitled'
			return this.casting.title
		},

		casting_items_grouped(){

			if( !this.casting.items ) return
			var items = JSON.parse(JSON.stringify(this.casting.items))
			return helpers.casting_items_groupify(items)

		},

	},

	methods: {

		get_casting() {

			var _this = this

			_this.loading = true
			
			this.fetch( 'get_casting', { uid:this.uid }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.casting ) {
					//console.log('valid request, but missing data')		
					_this.nocastingfound = true
					return
				}

				_this.casting = output.data.casting
				_this.nocastingfound = false
				_this.loading = false
				
			}, onError: function(output){

				//console.log('NAH - fetched but with error',output)		
				_this.nocastingfound = true
				_this.loading = false

			}})

		},

	},


	created(){
		
		
	},

	mounted(){

		if( this.uid ) {
			this.get_casting()
		}

	},

}
</script>



// WEBPACK FOOTER //
// src/views/CastingViewer.vue